import {Provider} from '@angular/core';

import {ListCitiesUseCase} from '@features/setting/application/use_cases/list-cities/list-cities.use-case';

import {
  ListCitiesHttpProvider
} from '@features/setting/infrastructure/http/list-cities/list-cities.http.provider';

export const ListCitiesUseCaseProvider: Provider[] = [
  ...ListCitiesHttpProvider,
  ListCitiesUseCase
];
